import { render, staticRenderFns } from "./CardCatalogueCard.vue?vue&type=template&id=3bf1161d&scoped=true"
import script from "./CardCatalogueCard.vue?vue&type=script&lang=js"
export * from "./CardCatalogueCard.vue?vue&type=script&lang=js"
import style0 from "./CardCatalogueCard.vue?vue&type=style&index=0&id=3bf1161d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1161d",
  null
  
)

export default component.exports